module.exports = __webpack_public_path__ + "img/17.60137d3.png";